<template>
    <div>
        <div v-if="!cover" class="file-area mx-auto" :class="{'invalid': errors}">
            <div>
                <input
                    ref="fileInput" type="file" @input="pickFile($event)">
                <img v-if="!previewImage" alt="" class="placeholder-img" src="/img/user.png">
                <img v-else :src="previewImage" alt="" class="uploaded">
            </div>
        </div>
        <div v-else class="mx-auto cover-file-area" :class="{'invalid': errors}">
            <div>
                <input
                    ref="fileInput" type="file" @input="pickFile($event)">
                <img v-if="!previewImage" alt="" class="cover-placeholder-img" src="/img/image.svg">
                <img v-else :src="previewImage" alt="" class="uploaded">
            </div>
        </div>
        <label class="form-label mt-3" for="field">
            <slot/>
        </label>
        <p>{{ subtitle }}</p>
        <div class="text-danger text-center">
            {{ errors }}
        </div>

    </div>
</template>

<script>
import bsCustomFileInput from "bs-custom-file-input";

export default {
    name: "ImageUpload",
    // props: ['cover', 'subtitle'],
    props: {
        cover: {
            type: Boolean,
            required: false,
            default: false,
        },
        subtitle: String,
        errors: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            previewImage: null
        };
    },
    mounted() {
      Bus.$on('reset-preview', () => {
          this.previewImage = "";
      })
    },
    methods: {
        selectImage() {
            this.$refs.fileInput.click()
        },
        isFileImage(file) {
            return file && file["type"].split("/")[0] === "image";
        },
        pickFile(event) {
            let image = event.target.files[0];
            if (!this.isFileImage(image)) {
                this.resetInput();
                return;
            }
            this.$emit("input", image);
            this.previewImage = URL.createObjectURL(image);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

label {
    @include font($mulish-bold, 18px, 30px, $hajde-pink);
    text-align: center;
    width: 100%;
}

.invalid {
    border: 1px solid red !important;
}

p {
    width: 100%;
    text-align: center;
    @include font($mulish-light, 18px, 30px, $hajde-black);
    opacity: 50%;
}

.file-area {
    position: relative;
    height: 220px;
    width: 220px;
    background-color: #EEEEEE;
    border-radius: 50%;
    overflow: hidden;

    input {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1000;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        cursor: pointer;
    }

    img.placeholder-img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    img.uploaded {
        position: absolute;
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: center;
    }
}


.cover-file-area {
    position: relative;
    height: 400px;
    width: 100%;
    background-color: #EEEEEE;
    //border-radius: 50%;
    overflow: hidden;

    input {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1000;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        cursor: pointer;
    }

    img.cover-placeholder-img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    img.uploaded {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
}


textarea {
    resize: none;
    padding: 15px 20px;
    border-radius: 15px;
    border: 1px solid rgba(109, 110, 112, 0.5);

    &::placeholder {
        @include font($mulish-light, 18px, 30px, $hajde-black);
        opacity: 50%;
    }
}
</style>
